export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WHATSAPP_NUMBER = "9191119119";
export const WHATSAPP_MESSAGE = "Hello Healthcare Solutions team, I would like to consult regarding hospital services.";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

export const CONTACT = {
  phone: "+91-9111919119",
  email: "info@healthcaresolution.co.in",
  address: "Ward No. 04, Shanti Nagar, Baihar Road, Balaghat – 481001, Madhya Pradesh",
};

export const COVER_PRESETS = [
  { label: "Hospital Building", url: "https://images.unsplash.com/photo-1769147555720-71fc71bfc216?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob3NwaXRhbCUyMGJ1aWxkaW5nJTIwYXJjaGl0ZWN0dXJlJTIwZXh0ZXJpb3IlMjBpbmZyYXN0cnVjdHVyZXxlbnwwfHx8fDE3OTAxMDE4Njl8MA&ixlib=rb-4.1.0&q=85" },
  { label: "Insurance Desk", url: "https://images.unsplash.com/photo-1562564055-71e051d33c19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwaW5zdXJhbmNlJTIwcGFwZXJ3b3JrJTIwb2ZmaWNlJTIwY29uc3VsdGluZyUyMG1lZXRpbmd8ZW58MHx8fHwxNzkwMTAxODcwfDA&ixlib=rb-4.1.0&q=85" },
  { label: "Doctors & Tablet", url: "https://images.pexels.com/photos/5452187/pexels-photo-5452187.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { label: "Consulting Meeting", url: "https://images.pexels.com/photos/8441780/pexels-photo-8441780.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { label: "Doctors Reviewing X-Ray", url: "https://images.pexels.com/photos/8770713/pexels-photo-8770713.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { label: "Doctor Consultation", url: "https://images.unsplash.com/photo-1758691462878-6edc3d3da1be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBJbmRpYW4lMjBob3NwaXRhbCUyMGhlYWx0aGNhcmUlMjBjb25zdWx0YXRpb24lMjBkb2N0b3IlMjB0ZWFtfGVufDB8fHx8MTc5MDEwMTg1OXww&ixlib=rb-4.1.0&q=85" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1758691462878-6edc3d3da1be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBJbmRpYW4lMjBob3NwaXRhbCUyMGhlYWx0aGNhcmUlMjBjb25zdWx0YXRpb24lMjBkb2N0b3IlMjB0ZWFtfGVufDB8fHx8MTc5MDEwMTg1OXww&ixlib=rb-4.1.0&q=85",
  hospitalBuilding: "https://images.unsplash.com/photo-1769147555720-71fc71bfc216?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob3NwaXRhbCUyMGJ1aWxkaW5nJTIwYXJjaGl0ZWN0dXJlJTIwZXh0ZXJpb3IlMjBpbmZyYXN0cnVjdHVyZXxlbnwwfHx8fDE3OTAxMDE4Njl8MA&ixlib=rb-4.1.0&q=85",
  insuranceDesk: "https://images.unsplash.com/photo-1562564055-71e051d33c19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwaW5zdXJhbmNlJTIwcGFwZXJ3b3JrJTIwb2ZmaWNlJTIwY29uc3VsdGluZyUyMG1lZXRpbmd8ZW58MHx8fHwxNzkwMTAxODcwfDA&ixlib=rb-4.1.0&q=85",
  doctorsTablet: "https://images.pexels.com/photos/5452187/pexels-photo-5452187.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  doctorsXray: "https://images.pexels.com/photos/8770713/pexels-photo-8770713.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  consultingMeeting: "https://images.pexels.com/photos/8441780/pexels-photo-8441780.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const STATE_OPTIONS = ["Madhya Pradesh", "Chhattisgarh", "Maharashtra", "Other"];

export const DESIGNATION_OPTIONS = [
  "Hospital Owner / Director",
  "Doctor",
  "Healthcare Administrator",
  "Healthcare Professional",
  "Insurance / TPA Professional",
  "Healthcare Entrepreneur",
  "General Public",
  "Other",
];

export const INTEREST_OPTIONS = [
  "Hospital Consultancy",
  "Insurance / TPA Support",
  "Cashless Process Support",
  "Hospital Empanelment",
  "Healthcare Staff Training",
  "Healthcare Business Collaboration",
  "Certification & Accreditation",
  "Healthcare Audits",
  "Reimbursement Support",
  "Claim Rejection Support",
  "Grievance Handling & Escalation",
  "Healthcare Awareness",
  "General Enquiry",
  "Other",
];

export const ENQUIRY_STATUSES = ["New", "Contacted", "In Progress", "Closed"];

export const SOCIAL_LINKS = {
  linkedin: "#",
  instagram: "https://www.instagram.com/healthcaressolutions/",
  facebook: "https://www.facebook.com/profile.php?id=61594864283164",
  youtube: "#",
};

export const ARTICLE_CATEGORIES = [
  "Hospital Management",
  "Insurance & Cashless",
  "Healthcare Awareness",
  "Healthcare Business",
  "Healthcare Administration",
];
